import { USER_ROLES, NAVIGATION_LINKS_DATA } from '../../constants';
import type { UserDetails } from '../../interfaces/UserDetailsInterface';

export const getRoleHomePath = (role: string): string =>
  role === USER_ROLES.LEAD_FACILITATOR || role === USER_ROLES.FACILITATOR
    ? NAVIGATION_LINKS_DATA.DASHBOARD.path
    : NAVIGATION_LINKS_DATA.OVERVIEW.path;

// Runtime check: userDetails exists but eoaId is absent when district selection is pending.
export const hasSelectedEoa = (user: UserDetails | undefined): user is UserDetails =>
  Boolean(user?.eoaId && user.role && user.district);
